import $ from 'jquery';

(function(){
    'use strict';

    $(window).on( "load", function() {
        const url = 'https://www.google.com';

        $('.js-quick-exit').on('click', function(evt){
            evt.stopPropagation();
            evt.preventDefault();

            if (typeof ga !== "undefined"){
                // eslint-disable-next-line no-undef
                ga("send", "event", "outbound", "click", url, {transport: "beacon", hitCallback: function(){ window.open(url); }});
            } else {
                window.open(url);
            }

            window.location.replace(url);
        });
    });

}());
